import { getResponseDefault } from '../helpers/api';
import { GameType } from '../helpers/enums';
import { factory } from './base';

export interface GameCategory {
  id: string;
  title: string;
}

export enum Category {
  TOP = 'top',
  NEW = 'new',
}

export interface GameD {
  title: string;
  provider: string;
  collections: {
    [providerId: string]: number;
  };
  real: {
    [currencyCode: string]: {
      id: number;
    };
  };
  demo?: string;
}

export type GamePackObject = {
  [id: string]: GameD;
};

export type Game = GameD & {
  id: string;
  path: string;
  fullPath: string;
  seoPath: string;
  listCollections: string[];
};

export interface ProviderD {
  id: string;
  title: string;
}

export interface Provider extends ProviderD {
  numberOfGames: number;
}

export const gameCategories = factory((r) => (lng: string) =>
  r<GameCategory[]>('get', `games/collections?l=${lng}`)
);

export const providers = factory((r) => () =>
  r<ProviderD[]>('get', `games/providers`)
);

// use default transformResponse
export const games = factory((r) => (type: GameType) =>
  r<GamePackObject>('get', `games/${type}`, undefined, {
    transformResponse: [getResponseDefault()],
  })
);

export const favoriteGames = factory((r) => () =>
  r<number[]>('get', `player/favorite_games`)
);

export const setFavoriteGame = factory((r) => (currencyCode: number) =>
  r<null>('put', `player/favorite_games/${currencyCode}`)
);

export const deleteFavoriteGame = factory((r) => (currencyCode: number) =>
  r<null>('delete', `player/favorite_games/${currencyCode}`)
);
